"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualConnectionTablesQueryGrid = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const VirtualConnectionTableRowDataFunctions_1 = require("../table/functions/VirtualConnectionTableRowDataFunctions");
const VirtualConnectionTablesDisplayGrid_1 = require("./VirtualConnectionTablesDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.virtualConnections && resultData.virtualConnections[0]
        && resultData.virtualConnections[0].tablesConnection;
}
function selectMaxCountsResult(resultData) {
    return resultData && resultData.virtualConnections && resultData.virtualConnections[0];
}
function getRowDataForVirtualConnectionTable(node, resultData) {
    return (0, VirtualConnectionTableRowDataFunctions_1.getRowDataWithMaxCountsForVirtualConnectionTable)(node, selectMaxCountsResult(resultData));
}
function VirtualConnectionTablesQueryGrid(props) {
    return (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.VirtualConnectionTablesByIdDocument, partialQueryVariables: {
            vizportalUrlId: props.vizportalUrlId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: getRowDataForVirtualConnectionTable }, ({ rowStore }) => (react_1.default.createElement(VirtualConnectionTablesDisplayGrid_1.VirtualConnectionTablesDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }))));
}
exports.VirtualConnectionTablesQueryGrid = VirtualConnectionTablesQueryGrid;
//# sourceMappingURL=VirtualConnectionTablesQueryGrid.js.map